
// This source is part of the Akeria  and is
// copyrighted by Uniphore system software limited.

// All rights reserved.  No part of this work may be reproduced, stored in a
// retrieval system, adopted or transmitted in any form or by any means,
// electronic, mechanical, photographic, graphic, optic recording or otherwise,
// translated in any language or computer language, without the prior written
// permission of  Uniphore system software limited.

// Uniphore system software limited.
// Vaishnavi Silicon Terrace, B- Block, 
// 3rd & 4th floor, Hosur Rd, 
// Adugodi, Bengaluru, Karnataka 560095

// India

// Copyright 2019 Uniphore system software limited.

// Modification History

// Date            Version          Author                            Description
// ----------     -----------      ---------------                   ----------------------------------------
// 20-11-2019   1                  Pappuraj                          Development
// 30-11-2019   1.1                Pappuraj                           Bug fixed 



import { Component, OnInit } from '@angular/core';
import { NavController, Platform, AlertController } from '@ionic/angular';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import * as moment from 'moment';
import { UsernameValidator } from 'src/app/validation/password.validator';
import { DatePicker } from '@ionic-native/date-picker/ngx';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';

declare var window: any


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  langcontext: any;
  context: any;
  headingTitle: any;
  username: any;
  dob: any;
  password: any;
  formsubmitted: any = false;
  loginedFlg: any;
  passshow: any = "password"
  agreecheck: any = false;
  token: any;
  year: any;
  public loginForm: FormGroup;
  public loginFormpass: FormGroup;
  startdate: any;
  maxDate: any;
  disclimerFlg: any = "false";



  constructor(private datePicker: DatePicker, public _sanitizer: DomSanitizer, public platform: Platform, public navCtrl: NavController, public alert: AlertController, public formBuilder: FormBuilder, public cmndef: CommonDefinitionService, public cmndecl: CommonDeclarationService, public api: RestapiService, public inappbrowser: InAppBrowser, public router: Router) {
    this.platform.ready().then(() => {
      localStorage.removeItem("tackbackenable");
      this.api.postapi("getContextMenu", {}).then(data => {
        console.log(data);
        this.cmndecl.storeProcess(data, "contexualmenu");
        this.api.postapi("getPopupConfigs", {}).then(data => {
          console.log(data);
          localStorage.configPage = JSON.stringify(data);
        }, err => {
          console.log("err");
        });
      }, err => {
        console.log("err");
      });

    });
    this.platform.backButton.subscribe(() => {
      console.log("TEST");
    });
    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['Login'];
    }
    else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].Login;
    }
    this.headingTitle = this.langcontext.LoginButton.label;

    if (localStorage.logined == null || localStorage.logined == undefined)
      this.loginedFlg = "new";
    else
      this.loginedFlg = "already";

    this.loginForm = formBuilder.group({
      username: ['', Validators.required],
      dob: ['', Validators.required],
      password: new FormControl('', Validators.compose([

        Validators.maxLength(20),
        Validators.minLength(6)
      ])),
    });
    this.loginFormpass = formBuilder.group({
      password: new FormControl('', Validators.compose([
        Validators.maxLength(20),
        Validators.minLength(6)
      ])),
    });
  }





  ngOnInit() {
    this.maxDate = new Date().toISOString();
    localStorage.removeItem("tackbackenable");

    if (localStorage.role == 'new') {
      this.cmndecl.deletefile();
      this.cmndecl.ChatFullHistory=[];
      this.cmndecl.ChatfullList =[];
      this.cmndecl.capsuleList = [];
      localStorage.removeItem("userSessionID")
      localStorage.removeItem("userChatSessionId")
      localStorage.removeItem("setUserData")
    }
  }

  showDatepicker() {
    if (this.cmndecl.cordovaSupport) {
      if (this.dob == undefined || this.dob == null || this.dob == "") {
        let fulldate = new Date('01/01/2001');
        let mdte = new Date();
        this.cmndef.showdatePicker(fulldate, "", mdte).then(data => {
          this.dob = data;
        }, err => {
          console.log(err);
        });
      }
      else {
        let split = this.dob.split("/");
        let sdate = split[1] + "/" + split[0] + "/" + split[2]
        let d = new Date(sdate);
        let mdte = new Date();
        this.cmndef.showdatePicker(d, "", mdte).then(data => {
          this.dob = data;
        }, err => {
          console.log(err);
        });
      }
    }
  }

  async Login(flg: any) {
    var start = window.performance.now();
    console.log("login invoked");
    localStorage.removeItem('banner');
    let reqdata: any;
    let fcmdata: any;
    let date = new Date(this.dob);
    let dobdate: any;
    let mobileno: any = "";
    let emailId: any = "";
    let letter: any;
    let response: any;
    if (flg) {
      if (this.cmndecl.cordovaSupport)
        dobdate = this.dob;
      else
        dobdate = moment(this.dob).format("DD/MM/YYYY");
    } else {
      dobdate = localStorage.dob;
      this.username = localStorage.usercred;
    }
    letter = /^\d{10}/;
    if ((this.loginedFlg == "new" && this.loginForm.valid && this.agreecheck) || (this.loginedFlg != "new" && this.loginFormpass.valid)) {
      if (this.username.match(letter)) {
        mobileno = this.username || "";
        emailId = '';
      }
      else {
        mobileno = "";
        emailId = this.username || "";
      }
      reqdata = {
        "channelId": this.cmndecl.channelId,
        "dob": dobdate,
        "emailId": emailId,
        "mobileNo": mobileno,
        "passcode": this.password,
        "requestType": "LOGIN",
        "userId": this.username,
        "userSessionID": ""
      }
      this.token = localStorage.pushToken;
      console.log(this.token);
      var start1 = window.performance.now();
      await this.api.postapi("loginAuthentication", reqdata).then(async res => {
        this.api.clickenventcap("submitLogin");
        this.cmndef.loaderstart();
        response = res;
        var end = window.performance.now();
        var time = end - start;
        console.log(time);
        reqdata = {
          "requestType": "FCMDATA",
          "uniqueId": response.uniqueId,
          "deviceId": this.token
        }
        console.time("updateDetails is called");
        await this.api.postapi("updateDetails", reqdata).then(data => {
          console.timeEnd("updateDetails response Received");
          console.time("LocalStorage is called");
          localStorage.user = mobileno;
          localStorage.usercred = this.username;
          localStorage.dob = dobdate;
          localStorage.logined = "logined";
          localStorage.role = "existing";
          localStorage.uniqueId = response.uniqueId;
          localStorage.log = "enable";
          this.cmndecl.loginCheck = true;
          localStorage.userChatSessionId = response.userChatSessionId;
          localStorage.userSessionID = response.userSessionID;
          localStorage.userType = "Existing";
          this.cmndecl.DefaultPolicyBlock = true;
          console.timeEnd("localStorage is stopped");
          this.cmndef.loaderend();
          console.time("navigation started");
          if (localStorage.configPage != undefined && localStorage.configPage != "" && localStorage.configPage != []) {
            let d = localStorage.getItem('configPage');
            let dparse = JSON.parse(d);
            if (dparse != undefined && dparse != "" && dparse != []) {
              dparse = dparse.values;
              let count = 1;
              let df = [];
              for (var s = 0; s < dparse.length; s++) {
                count = count + 1;
                if (dparse[s].popupType == 'P' && dparse[s].popupDeviceType == 'A') {
                  df.push('0');
                } else {
                  df.push('1');
                }
              }
              if (this.langcontext.popupvalidate.reset == 'true' && localStorage.popupvalidate != this.langcontext.popupvalidate.updateflg) {
                localStorage.popupvalidate = this.langcontext.popupvalidate.updateflg;
                localStorage.removeItem('nothanks');
                localStorage.removeItem('banner');
                var bannnervisited = localStorage.getItem('banner');
                if (df.indexOf("0") !== -1 && bannnervisited != 'displayed') {
                  sessionStorage.CurrentPage = "/va/popupconfig";
                  this.navCtrl.navigateRoot("/va/popupconfig");
                } else {
                  sessionStorage.CurrentPage = "/va/chat"
                  this.navCtrl.navigateRoot("/va/chat");
                }
              } else {
                var bannnervisited = localStorage.getItem('banner');
                if (df.indexOf("0") != -1 && bannnervisited != 'displayed') {
                  sessionStorage.CurrentPage = "/va/popupconfig"
                  this.navCtrl.navigateRoot("/va/popupconfig");
                } else {
                  sessionStorage.CurrentPage = "/va/chat"
                  this.navCtrl.navigateRoot("/va/chat");
                }
              }
            } else {
              sessionStorage.CurrentPage = "/va/chat"
              this.navCtrl.navigateRoot("/va/chat");
            }
          } else {
            sessionStorage.CurrentPage = "/va/chat"
            this.navCtrl.navigateRoot("/va/chat");
          }
        }, err => {
          this.cmndef.loaderend();
          console.log(err);
        })
        console.timeEnd("Navigation Ended");
      }, err => {
        console.log(err);
      })
    }
  }

  logindiff() {
    localStorage.removeItem("user");
    localStorage.removeItem("dobdate");
    localStorage.removeItem("logined");
    localStorage.removeItem("role");
    localStorage.removeItem("dob");
    localStorage.removeItem("state");
    this.cmndecl.deleteProcess("profile");
    localStorage.removeItem("logout");
    this.cmndecl.deletefile();
    this.cmndecl.ChatFullHistory=[];
    this.cmndecl.ChatfullList =[];
    this.cmndecl.capsuleList = [];
    localStorage.removeItem("uniqueId");
    localStorage.removeItem("userChatSessionId");
    localStorage.removeItem("userSessionID");
    localStorage.removeItem('nothanks');
    localStorage.removeItem('banner');
    localStorage.removeItem("voiceenable")
    localStorage.removeItem('policyNo');
    sessionStorage.CurrentPage = "/preRegister";
    this.navCtrl.navigateRoot("/preRegister");
  }

  toggleShow() {
    if (this.passshow == "text") {
      this.passshow = "password"
    }
    else {
      this.passshow = "text";
    }
  }

  async disclaimer() {
    this.cmndecl.Actionsheetenable = true;
    this.disclimerFlg = "true";
  }

  forgotpwdpage() {
    console.log("click fpwd")
    sessionStorage.CurrentPage = "/forgotpassword"
    this.navCtrl.navigateRoot("/forgotpassword")
  }


  Loadingappbrowser(link: any) {
    if(this.cmndecl.BrowserBuild != 1)
      this.inappbrowser.create(link);
    else
      window.open(link,"_blank")
  }

  termscont() {
    if (this.agreecheck == false)
      this.agreecheck = true
    else
      this.agreecheck = false
  }
  showinfo(msg) {
    this.cmndef.presentAlert("", msg, "info");
  }

  validatefun(event: any, flg: any) {

    if (flg == 'password') {
      this.password = this.password.replace(" ", '');
    }

  }

  validateemail(){
    this.username = this.username.replace(/[^A-Za-z0-9!@#$%^&*()+_.,'"]/g, "")
  }
}
